import { render, staticRenderFns } from "./Practice.html?vue&type=template&id=692345e8&"
import script from "./Practice.js?vue&type=script&lang=js&"
export * from "./Practice.js?vue&type=script&lang=js&"
import style0 from "./Practice.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports